import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'permissions',
            name: 'permission',
            class: 'App\\Models\\Permission'
        }
    }
}